/*=========================================================================================
  File Name: module-usertax-getters.js
  Description: UserTax Module Getters
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import commonFunc from '@/common/commonFunction';

export default {
	TaxPaperFilterCode: function(state) {
		return commonFunc.getDataFromEnum('TaxPaperFilterCode');
	},
	TaxPaperPayerName: function(state) {
		return commonFunc.getDataFromEnum('TaxPaperPayerName');
	},
	MTaxStatus: function(state) {
		return commonFunc.getDataFromEnum('MTaxStatus');
	},
	TaxPaperFilterDate: function(state) {
		return commonFunc.getDataFromEnum('TaxPaperFilterDate');
	},
	TaxPaperList: function(state) {
		return state.TaxPaperList;
	},
	TypeOfMoney: function(state) {
		return commonFunc.getDataFromEnum('TypeOfMoney');
	},
	TypeOrgAuthority: function(state) {
		return commonFunc.getDataFromEnum('TypeOrgAuthority');
	},
	TypeTaxPeriod: function(state) {
		return commonFunc.getDataFromEnum('TypeTaxPeriod');
	},
	PayerBankList: function(state) {
		return state.PayerBankList;
	},
	TotalTaxPaperList: function(state) {
		return state.TotalTaxPaperList;
	},
	PayTaxPaymentSubmission: function(state) {
		return state.PayTaxPaymentSubmission;
	},
	PayTaxPaymentSubmissionDefault: function(state) {
		return state.PayTaxPaymentSubmissionDefault;
	},
	regisSuccess: function(state) {
		return state.regisSuccess;
	},
	GIPInfo: function(state) {
		return state.GIPInfo;
	},
	taxPaperLoaded: function(state) {
		return state.taxPaperLoaded;
	},
	DashboardPaymentByEconomic: function(state) {
		return state.DashboardPaymentByEconomic;
	},
	getBankByTaxPaper: function(state) {
		return state.bankByTaxPaper;
	},

	getMustPayTaxAmountReportData: function(state) {
		return state.MustPayTaxAmountReportData;
	},
	getMustPayTaxAmountReportSummary: function(state) {
		return state.MustPayTaxAmountReportSummary;
	},
	getMustPayTaxAmountReportDetailData: function(state) {
		return state.MustPayTaxAmountReportDetailData;
	},
	getMustPayTaxAmountReportDetailTotal: function(state) {
		return state.MustPayTaxAmountReportDetailTotal;
	}
};
